export default __webpack_public_path__ + "static/media/backpackMan.39dcd566.png";